export default "__VITE_ASSET__B4z2xE5S__"